import React from 'react';
import { Image } from '@chakra-ui/react';
import { ImageContainer } from './styles'; // Importuj styled component

interface CarouselImageProps {
    imageUrl: string;
    alt: string;
}

const CarouselImage: React.FC<CarouselImageProps> = ({ imageUrl, alt }) => {
    return (
        //TODO  Przepisać na chakra UI
        <ImageContainer>
            <Image filter={'grayscale(100%)'} src={imageUrl} alt={alt} />
        </ImageContainer>
    );
};

export default CarouselImage;
